import SecurityContainer from './containers/SecurityContainer';

export default SecurityContainer;
